/*
    This is a block group that allows a user to set their search criteria on WHAT to search for
    as well as WHERE to search for it.
*/

import React, { useState } from 'react';

// mui components
import { Grid, Button, TextField, MenuItem, OutlinedInput, FormControl, InputAdornment, IconButton } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

const SearchField = ({ fieldOptions = [{ value: 'none', title: 'None'}], initialSearchBy = "", initialSearchValue = "", onSearchClicked, onClearClicked }) => {

    // Props
    // onSearchClicked is a prop that holds the callback function to be executed when the Search Button is Clicked.
    // fieldOptions is the list of fields that can be searched through, which will be displayed in the "searchBy" dropdown.

    const [searchValue, setSearchValue] = useState(initialSearchValue)
    const [searchValueError, setSearchValueError] = useState(false)
    const [searchBy, setSearchBy] = useState(initialSearchBy)
    const [searchByError, setSearchByError] = useState(false)
    
    const handleSearchClicked = (e) => {
        e.preventDefault()

        // make sure that both fields have values and are not empty
        if(searchBy === "") {
            setSearchByError(true)
            if(searchValue === "") {
                setSearchValueError(true)
            }
        } 
        else {
            onSearchClicked(searchValue, searchBy)
            setSearchByError(false)
            setSearchValueError(false)
        }
    }

    const handleClearClicked = () => {
        setSearchByError(false)
        setSearchValueError(false)
        setSearchValue("")
        setSearchBy('')
        onClearClicked()
    }
    

    return (<Grid container spacing={2}>
        {/* Input Field */}
        <Grid item xs={4}>
            <FormControl variant="outlined" fullWidth>
                <OutlinedInput
                    type={'text'}
                    size={'small'} 
                    error={searchValueError}
                    fullWidth 
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)} 
                    endAdornment={searchValue !== "" &&
                    <InputAdornment position="end">
                        <IconButton
                        aria-label="toggle password visibility"
                        size='small'
                        edge="end"
                        onClick={handleClearClicked}
                        >
                        <ClearIcon fontSize='small' />
                        </IconButton>
                    </InputAdornment>
                    }
                />
            </FormControl>
        </Grid>
       
        {/* Filter By Field - Dropdown */}
        <Grid item xs={2}>
            <TextField 
            select
            label="Search By"
            size={'small'}
            error={searchByError}
            value={searchBy}
            onChange={(e) => setSearchBy(e.target.value)}
            fullWidth>
                {
                    fieldOptions.map(option => {
                        return (<MenuItem key={option.value} value={option.value}>{option.title}</MenuItem>)
                    })
                }
            </TextField>
        </Grid>
        
        {/* Search Button */}
        <Grid item xs={2} alignItems='stretch'>
            <Button variant='contained' size={'large'} color='inherit' onClick={handleSearchClicked}>Search</Button>
        </Grid>
    </Grid>)
}

export default SearchField;